import { createAction, props } from "@ngrx/store";
import { KeycloakToken } from "@youm-front/keycloak/domain";

export const keycloakSignIn = createAction("[Account Auth] Keycloak Sign In");
export const keycloakSignInSuccess = createAction(
  "[Account Auth] Keycloak Sign In Success",
  props<{ token: KeycloakToken }>()
);
export const keycloakSignInFailure = createAction(
  "[Account Auth] Keycloak Sign In Failure",
  props<{ error: string }>()
);

export const keycloakSignOut = createAction("[Account Auth] Keycloak Sign Out");
